import { type PropsWithChildren, useCallback } from 'react'
import { type InternalAxiosRequestConfig } from 'axios'
import { useAxiosInstance, useRequestHeader, useRequestInterceptor } from '@dhl/axios'
import { useKeycloakTokens } from './KeycloakTokensProvider'

export const KeycloakAxiosConnector = ({ children }: PropsWithChildren) => {
  const { token, sessionId } = useKeycloakTokens()
  const axiosInstance = useAxiosInstance()

  const onFulfilled = useCallback(
    (config: InternalAxiosRequestConfig) => {
      // Only add the X-Transaction-ID to requests to our own domain! Other domains may trigger a preflight CORS request
      // Which may be accept causing a delay due to the second round trip, or it may fail and cause the application to stop
      // working correctly.
      const uri = axiosInstance.getUri(config)

      if (sessionId && (uri.startsWith('/') || new URL(uri).hostname === window.location.hostname)) {
        return { ...config, headers: config.headers.set('X-Transaction-ID', sessionId) }
      }

      return config
    },
    [sessionId, axiosInstance]
  )

  useRequestInterceptor(onFulfilled)
  useRequestHeader('Authorization', `Bearer ${token}`)

  return children
}
